import React, { useState } from 'react';
import { Modal, Tabs, Input, Button, List, Space } from 'antd';

const { TabPane } = Tabs;

function ManageModal({ visible, onClose, symbols, altSymbols, updateSymbols, updateAltSymbols }) {
  const [newStock, setNewStock] = useState('');
  const [newCrypto, setNewCrypto] = useState('');

  const handleAddSymbol = (type) => {
    if (type === 'stock' && newStock) {
      updateSymbols([...symbols, newStock]);
      setNewStock('');
    } else if (type === 'crypto' && newCrypto) {
      updateAltSymbols([...altSymbols, newCrypto]);
      setNewCrypto('');
    }
  };

  return (
    <Modal
      title="管理自选"
      visible={visible}
      onCancel={onClose}
      footer={null}
    >
      <Tabs defaultActiveKey="1">
        <TabPane tab="股票" key="1">
          <Space direction="vertical" style={{ display: 'flex' }}>
            <List
              size="small"
              bordered
              dataSource={symbols}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button
                      type="link"
                      onClick={() =>
                        updateSymbols(symbols.filter((s) => s !== item))
                      }
                    >
                      删除
                    </Button>,
                  ]}
                >
                  {item}
                </List.Item>
              )}
            />

            <Input
              placeholder="添加股票"
              value={newStock}
              allowClear
              onChange={(e) => setNewStock(e.target.value)}
              onPressEnter={() => handleAddSymbol('stock')}
            />
            <Button type="primary" onClick={() => handleAddSymbol('stock')}>
              添加
            </Button>
          </Space>
        </TabPane>
        <TabPane tab="币种" key="2">
          <Space direction="vertical" style={{ display: 'flex' }}>
            <List
              size="small"
              bordered
              dataSource={altSymbols}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Button
                      type="link"
                      onClick={() =>
                        updateAltSymbols(altSymbols.filter((s) => s !== item))
                      }
                    >
                      删除
                    </Button>,
                  ]}
                >
                  {item}
                </List.Item>
              )}
            />
            <Input
              placeholder="添加币种"
              value={newCrypto}
              allowClear
              onChange={(e) => setNewCrypto(e.target.value)}
              onPressEnter={() => handleAddSymbol('crypto')}
            />
            <Button type="primary" onClick={() => handleAddSymbol('crypto')}>
              添加
            </Button>
          </Space>
        </TabPane>
      </Tabs>
    </Modal>
  );
}

export default ManageModal; 